import { cva, type VariantProps } from "class-variance-authority";
import { FC } from "react";

const statusBadgeVariants = cva(
  "w-max rounded-full px-2 py-0.5 text-[10px] capitalize text-white",
  {
    variants: {
      variant: {
        paused: "bg-[#867705]",
        trial: "bg-[#1f6a46]",
        expiring: "bg-[#DC4949]",
        canceled: "bg-[#DC2626]",
        expired: "bg-[#323232]",
      },
    },
  },
);

type StatusBadgeProps = {
  text: string;
} & Required<VariantProps<typeof statusBadgeVariants>>;

export const StatusBadge: FC<StatusBadgeProps> = ({ text, variant }) => {
  return <div className={statusBadgeVariants({ variant })}>{text}</div>;
};

export type StatusBadgeVariant = NonNullable<
  VariantProps<typeof statusBadgeVariants>["variant"]
>;
